/**
 * @return {string}
 */
const Fetch = function (key) {
  try {
    return JSON.parse(window.localStorage.getItem(key))
  } catch(err) {
    return err
  }
}
const Save = function (key, items) {
  window.localStorage.setItem(key, JSON.stringify(items))
}

export {Fetch, Save}